<template>
  <div class="successContainer">
    <div class="title">订单提交成功</div>
    <div class="content">
      点击前往查看<span @click="goOrder" class="orderEnter">订单信息</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("edit_backgroundColor", "#3e3e3e");
  },
  destroyed() {
    this.$store.commit("edit_backgroundColor", "rgba(0, 0, 0, 1)");
  },
  methods: {
    goOrder() {
      this.$store.commit("edit_showAccount", false);

      this.$router.push("/orderInfo");
    }
  }
};
</script>

<style lang="less">
.successContainer {
  width: 100%;
  max-width: 1020px;
  padding: 120px 24px 0;
  margin: 0 auto;
  .title {
    font-size: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #d8d8d8;
  }
  .content {
    margin-top: 24px;
    font-size: 16px;
  }
  .orderEnter {
    padding-bottom: 2px;
    border-bottom: 1px solid #fc9900;
    cursor: pointer;
  }
}
</style>
